const chosen = value => typeof value === "string" && !!value.trim() && value.trim() !== "not_decided";
export function childrensBookSavedAudienceReady(audience = {}) {
  return chosen(audience?.ageRange) && chosen(audience?.readingLevel) &&
    chosen(audience?.readingArrangement);
}
